export default class AddData {
  addData: any;
  
  constructor(addDataWidget: any) {
    this.addData = addDataWidget;
  }

}